import { render, staticRenderFns } from "./PecaEstudanteForm.vue?vue&type=template&id=734678dc"
import script from "./PecaEstudanteForm.vue?vue&type=script&lang=js"
export * from "./PecaEstudanteForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports